<template>
    <div>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Status do Item</label>
                    <b-form-select
                        :options="statusContratoOptions"
                        v-model="statusContrato"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Tipo de Faturamento</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="tipoFaturamentoFixo"
                            :disabled="true"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
                <!-- <b-form-group>
                    <label
                        class="required"
                    >Tipo de Faturamento</label>
                    <b-form-select
                        :options="tiposFaturamento"
                        v-model="tipoFaturamento"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group> -->
            </b-col> 
            <!-- <b-col sm="12" md="3" v-if="mostrarNaturezaItem">
                <b-form-group>
                    <label
                        class="required"
                    >Natureza do Item</label>
                    <b-form-select
                        :options="naturezaItemOptions"
                        v-model="naturezaItem"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col> -->
            <!-- <b-col sm="12" md="3" v-if='tipoFaturamento=="1"'>
                <b-form-group>
                    <label
                        class="required"
                    >Prazo de Pagamento</label>
                    <date-picker
                        v-model="prazoPagamento"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col> -->
        </b-row>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Produto</label>
                    <model-list-select
                        :list="tiposProduto"
                        option-text="descricao"
                        option-value="codigo"
                        v-model="tipoProduto"
                    ></model-list-select>
                </b-form-group> 
            </b-col>
            <!-- <b-col sm="12" md="3">
                <b-form-group>
                    <label>Unidade</label>
                    <b-form-select
                        :options="unidades"
                        v-model="unidade"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col> -->
            <b-col sm="12" md="3">
                    <b-form-group>
                        <label
                            class="required"
                        >Quantidade</label>
                        <b-form-input 
                            type="number" 
                            v-model="quantidade"
                            min="0"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label
                        class="required"
                    >Valor</label>
                    <money
                        v-model="valor"
                        v-bind="money"
                        class="form-control text-right"
                    ></money>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Desconto</label>
                    <money
                        v-model="desconto"
                        v-bind="money"
                        class="form-control text-right"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label
                        class="required"
                    >Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="4"
                        @input="$v.descricao.$touch()"
                        :state="
                            $v.descricao.$error
                                ? false
                                : null
                        "
                    ></b-form-textarea>
                    <b-form-invalid-feedback>A descrição é obrigatória</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição Resumida</label>
                    <b-form-textarea 
                        v-model="descricaoResumida" 
                        :rows="4" 
                        :maxlength="200"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { situacaoContrato } from '../../SituacaoContrato'

export default {
    components: {
        ModelListSelect
    },

    props: {
        statusContratoOptions: {
            type: Array,
            default: () => {}
        },
        tiposProduto: {
            type: Array,
            default: () => {}
        },
        // unidades: {
        //     type: Array,
        //     default: () => {}
        // },
        naturezaItemOptions: {
            type: Array,
            default: () => {}
        },
        tiposFaturamento: {
            type: Array,
            default: () => {}
        },
        contrato: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: String,
            default: () => ""
        },
        item: {
            type: Object,
            default: () => {}
        },
    },
    
    data() {
        return {
            tipoFaturamentoFixo: 'Por Medição',
            tipoFaturamento: '2',
            // prazoPagamento: null,
            statusContrato: '',
            tipoProduto: '',
            // unidade: '',
            valor: '',
            quantidade: 0,
            desconto: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            descricao: '',
            descricaoResumida: '',
            isValid: false,
            naturezaItem: '',
        }
    },

    methods: {
        verificarAcao() {
            if (this.acao == 'Inserir'){
                this.preencherFormInserir()
            } else {                
                this.preencherFormAtualizar()
            }
        },

        preencherFormInserir() {
            this.statusContrato = this.contrato.dadosContratoRM.statusContratoRMDto.codigo
        },

        preencherFormAtualizar() {
            this.tipoFaturamento = 2
            this.statusContrato = this.item.codStatus
            this.tipoProduto = this.item.codTipoProduto
            // this.unidade = this.item.codUnidade
            this.valor = this.item.valorUnitario
            this.quantidade = this.item.quantidade
            this.desconto = this.item.desconto
            this.descricao = this.item.descricao
            this.descricaoResumida = this.item.descricaoResumida
            this.naturezaItem = this.item.codNatureza
        }, 

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

    },

    computed: {
        cabecalho() {
            return {
                tipoFaturamento: this.tipoFaturamento,
                // prazoPagamento: this.prazoPagamento,
                statusContrato: this.statusContrato,
                tipoProduto: this.tipoProduto,
                // unidade: this.unidade,
                valor: this.valor,
                quantidade: this.quantidade,
                desconto: this.desconto,
                descricao: this.descricao,
                descricaoResumida: this.descricaoResumida,
                naturezaItem: this.naturezaItem,
                invalid: this.$v.$invalid
            }
        },
        mostrarNaturezaItem(){
            return this.contrato.dadosContratoRM.naturezaContratoRMDto.codigo == 2
        }
    },

    created() {
        this.verificarAcao()
    },
    
    mounted() {
    },

    watch: {
        cabecalho() {
            this.$emit('atualizarCabecalho', this.cabecalho)
        },
    },

    validations: {
        statusContrato: {
            required
        },
        tipoFaturamento: {
            required
        },
        // prazoPagamento: {
        //     dataObrigatoria() {
        //         if (this.tipoFaturamento == "1" && this.prazoPagamento == null){
        //             return false
        //         } 
        //         return true
        //     }
        // },
        tipoProduto: {
            required
        },
        quantidade: {
            required
        },
        valor: {
            required
        },
        descricao: {
            required,
        },
        // naturezaItem: {
        //     naturezaItemObrigatoria() {
        //         if (this.mostrarNaturezaItem && this.naturezaItem === ''){
        //             return false
        //         }
        //         return true
        //     }
        // }
    },

}

</script>

<style>

</style>